<template>
  <div>
    <el-form
      ref="form"
      :model="form"
      label-width="250px"
      @submit.prevent="onSubmit"
      style="margin:20px;width:60%;min-width:600px;"
    >
      <el-form-item label="Serial Number">
        <el-input v-model="form.serialNumber"></el-input>
      </el-form-item>
      <el-form-item label="IP Address">
        <el-input v-model="form.ipAddress"></el-input>
      </el-form-item>
      <el-form-item label="Net Mask">
        <el-input v-model="form.netMask"></el-input>
      </el-form-item>
      <el-form-item label="Mac Address">
        <el-input v-model="form.macAddress"></el-input>
      </el-form-item>
      <el-form-item label="Internet Connection">
        <el-switch v-model="form.internetConnection" disabled on-text off-text></el-switch>
      </el-form-item>
      <el-form-item label="Cloud Server Connection">
        <el-switch v-model="form.cloudServerConnection" disabled on-text off-text></el-switch>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>

import Axios from 'axios';
import SettingsService from '@/api/settings.service';

export default {
  data() {
    return {
      form: {
        serialNumber: '',
        ipAddress: '',
        netMask: '',
        macAddress: '',
        internetConnection: false,
        cloudServerConnection: false,
      }
    }
  },
  mounted() {
    this.getData();
    setInterval(this.getData, 1000);
  },
  methods: {
    getData() {
      Axios.all([
        SettingsService.getNetworkSettings()
      ]).then(Axios.spread((networkSettingsResponse) => {
        this.form.serialNumber = networkSettingsResponse.data.id;
        this.form.ipAddress = networkSettingsResponse.data.network.eth0[0].address;
        this.form.netMask = networkSettingsResponse.data.network.eth0[0].netmask;
        this.form.macAddress = networkSettingsResponse.data.network.eth0[0].mac;
        this.form.internetConnection = networkSettingsResponse.data.internetConnected;
        this.form.cloudServerConnection = networkSettingsResponse.data.rabbitServerConnected;
      }));
    }
  }
}

</script>

<style scoped>
.chart-container {
  width: 100%;
  float: left;
}
/*.chart div {
        height: 400px;
        float: left;
    }*/

.el-col {
  padding: 30px 20px;
}
</style>


// WEBPACK FOOTER //
// Network.vue?5ac83665